/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRole } from './ProjectRole';
import {
    ProjectRoleFromJSON,
    ProjectRoleFromJSONTyped,
    ProjectRoleToJSON,
    ProjectRoleToJSONTyped,
} from './ProjectRole';

/**
 * 
 * @export
 * @interface ProjectInvitation
 */
export interface ProjectInvitation {
    /**
     * 
     * @type {ProjectRole}
     * @memberof ProjectInvitation
     */
    role?: ProjectRole | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectInvitation
     */
    isOwner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvitation
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectInvitation
     */
    created?: Date;
}

/**
 * Check if a given object implements the ProjectInvitation interface.
 */
export function instanceOfProjectInvitation(value: object): value is ProjectInvitation {
    return true;
}

export function ProjectInvitationFromJSON(json: any): ProjectInvitation {
    return ProjectInvitationFromJSONTyped(json, false);
}

export function ProjectInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] === undefined ? undefined : json['role'] === null ? null : ProjectRoleFromJSON(json['role']),
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'id': json['id'] == null ? undefined : json['id'],
        'token': json['token'] == null ? undefined : json['token'],
        'email': json['email'] == null ? undefined : json['email'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
    };
}

export function ProjectInvitationToJSON(json: any): ProjectInvitation {
    return ProjectInvitationToJSONTyped(json, false);
}

export function ProjectInvitationToJSONTyped(value?: ProjectInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': ProjectRoleToJSON(value['role']),
        'isOwner': value['isOwner'],
        'id': value['id'],
        'token': value['token'],
        'email': value['email'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
    };
}

